export default {"src":"/_next/static/media/icon-visa.6a79b539.svg","height":20,"width":31,"blurWidth":0,"blurHeight":0};